var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRefresh48Line = function SvgIconRefresh48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.35 12.41-1.08 4.45A14.186 14.186 0 0 0 24 9.8C16.17 9.8 9.8 16.17 9.8 24c0 7.83 6.37 14.2 14.2 14.2 6.48 0 12.14-4.38 13.75-10.65l-3.29-.85A10.787 10.787 0 0 1 24 34.79c-5.96 0-10.8-4.84-10.8-10.8 0-5.96 4.84-10.8 10.8-10.8 4.12 0 7.8 2.33 9.61 5.88l-5.18-1.52-.96 3.26 7.67 2.26a2.842 2.842 0 0 0 2.26-.27c.68-.39 1.18-1.06 1.37-1.83l1.88-7.77-3.3-.8v.01Z",
    fill: "current"
  })));
};
export default SvgIconRefresh48Line;